import axios from "axios";
import ClientOAuth2 from "client-oauth2";
import ApiAuthenService from '@/services/data-service/ApiAuthenService';
import store from "@/store";
export default class AuthService {
  getUserInfo(){
    return ApiAuthenService().get("auth/GetUserInfo/")
  }
  requestToken(){
    return ApiAuthenService().get("auth/RequestToken/")
  }
  refreshToken_msp(){
    const jwt = store.state.jwt;

    return ApiAuthenService().post("auth/refreshToken",{
      Token: jwt.token,
      RefreshToken: jwt.refreshToken,
    })
  }
  getSP(){
    const id_product = process.env.VUE_APP_ID_PRODUCT_FAMILY
    const id_org = store.state.userInfo.id_org;
    const id_role = store.state.userInfo.id_role;
    return ApiAuthenService().get("Sps/getSP/"+ id_product +"/"+ id_role + "/" + id_org)
  }
  getPaidby(){
    const id_sp = store.state.sp.id_sp;
    const id_role = store.state.userInfo.id_role;
    return ApiAuthenService().get(`Sps/getPaidbyShow/${id_sp}/${id_role}`)
  }
  getOauthConfig(){ 
    const _app_key =    process.env.VUE_APP_CLIENT_SECRET;
    const oauthAuth = new ClientOAuth2({
      clientId: process.env.VUE_APP_CLIENT_ID,
      clientSecret: _app_key,
      accessTokenUri: process.env.VUE_APP_ACCESS_TOKEN_URI,
      authorizationUri: process.env.VUE_APP_AUTHORIZATION_URI,
      redirectUri: process.env.VUE_APP_REDIRECT_URI,
      scopes: ['profile', 'offline_access']
    })
    return oauthAuth;
  }
  refreshToken(_refreshToken: string){
    const param = new URLSearchParams()
    param.append('refresh_token', _refreshToken)
    param.append('grant_type', 'refresh_token')
    param.append('client_id', process.env.VUE_APP_CLIENT_ID)
    param.append('client_secret', process.env.VUE_APP_CLIENT_SECRET)
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    return axios.post(process.env.VUE_APP_ACCESS_TOKEN_URI, param,config);
    
  }
  logoutOauth2(callback: string){
    window.location.href = process.env.VUE_APP_LOG_OUT_OAUTH_URL + callback;
  }
}
